var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ComponentWithFloatingIconDownload',{attrs:{"component-name":"RemoteFacebookAd","componentProps":{
    post: _vm.post,
    copyAd: _vm.copyAd,
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }